import { cloneDeep } from 'lodash'

/**
 * Config for {@link TheNavbar} and {@link BaseBreadCrumbs} components
 * path - route path. The same like in router
 * name - route name. The same like in router
 * isHiddenInNavbar - this route should be hidden in navbar
 * children - if this route has child routes
 * isHiddenInBreadcrumbs - if this component should not be placed in breadcrumbs
 * showChildrenInNavbar - if route has children that should be shown in navbar
 * isChildrenVisible - if route has children that should be pushed to the route
 * title - name of browser tab
 */
const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    label: 'Dashboard',
    isHiddenInNavbar: true,
    icon: 'home'
  },
  {
    path: '/reports',
    name: 'reports',
    label: 'Reports',
    icon: 'chart',
    isHiddenInNavbar: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'rank-zone',
        name: 'rank-zone',
        label: 'Rank Zone',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        isHiddenInBreadcrumbs: true,
        displayNextChildrenLevel: true,
        children: [
          // {
          //   path: 'overview',
          //   name: 'overview',
          //   navBarLabel: 'Overview',
          //   label: 'Rank Zone Reports - Overview',
          //   title: 'Rank Zone Reports | Overview'
          // },
          {
            path: 'progress',
            name: 'progress',
            navBarLabel: 'Progress',
            label: 'Rank Zone Reports - Progress',
            title: 'Rank Zone Reports | Progress'
          },
          {
            path: 'comparison',
            name: 'comparison',
            navBarLabel: 'Comparison',
            label: 'Rank Zone Reports - Comparison',
            title: 'Rank Zone Reports | Comparison'
          },
          {
            path: 'sections',
            name: 'sections',
            navBarLabel: 'Sections',
            label: 'Rank Zone Reports - Sections',
            title: 'Rank Zone Reports | Sections'
          },
          {
            path: 'status',
            name: 'status',
            navBarLabel: 'Status',
            label: 'Rank Zone Reports - Status',
            title: 'Rank Zone Reports | Status'
          },
          {
            path: 'url',
            name: 'url',
            navBarLabel: 'URL',
            label: 'Rank Zone Reports - URL',
            title: 'Rank Zone Reports | URL'
          }
        ]
      },
      {
        path: 'grids',
        name: 'product-grid-report',
        // visible: false,
        label: 'Product Grid Report',
        showChildrenInNavbar: true
      },
      {
        path: 'keyword-movement-report',
        name: 'keyword-movement-report',
        label: 'Keyword Movement Report',
        showChildrenInNavbar: true
      },
      {
        path: 'url-movement-report',
        name: 'url-movement-report',
        label: 'URL Movement Report',
        showChildrenInNavbar: true
      },
      {
        path: 'attribute',
        name: 'attribute',
        showChildrenInNavbar: true,
        isHiddenInNavbar: true,
        label: 'Attribute Report'
      },
      {
        path: 'link-building',
        name: 'link-building',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Link Building',
        label: 'Link Building',
        title: 'Strategy - Link Building'
      }
    ]
  },
  {
    path: '/strategy',
    name: 'strategy',
    label: 'Strategy',
    icon: 'monitor',
    isHiddenInNavbar: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'url-planner',
        name: 'url-planner',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Content Briefs',
        label: 'Content Briefs',
        title: 'Strategy - Content Briefs'
      },
      {
        path: 'calendar',
        name: 'calendar',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Calendar',
        label: 'Calendar',
        title: 'Strategy - Calendar'
      },
      {
        path: 'campaign-guidelines',
        name: 'campaign-guidelines',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Campaign Guidelines',
        label: 'Campaign Guidelines',
        title: 'Strategy - Campaign Guidelines'
      }
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    label: 'Settings',
    icon: 'gear',
    isHiddenInNavbar: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'project-membership',
        name: 'project-membership',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Membership',
        label: 'Project Membership',
        title: 'Settings - Project Membership'
      },
      {
        path: 'user-account',
        name: 'user-account',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'My Account',
        label: 'My Account',
        title: 'Settings - My Account'
      },
      {
        path: 'account-checklist',
        name: 'account-checklist',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Setup Checklist',
        label: 'Setup Checklist',
        title: 'Settings - Setup Checklist'
      }
    ]
  },
  {
    path: '/data',
    name: 'data',
    label: 'Data',
    icon: 'list',
    isHiddenInNavbar: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: []
  },
  {
    path: '/system',
    name: 'system',
    label: 'System',
    icon: 'key',
    isHiddenInNavbar: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: []
  }
]

const agencyRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    label: 'Dashboard',
    isHiddenInNavbar: true,
    icon: 'home'
  },
  {
    path: '/strategy',
    name: 'strategy',
    children: [
      {
        path: 'keyword-census',
        name: 'keyword-census',
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Keywords',
        label: 'Keywords',
        title: 'Strategy - Keywords'
      },
      {
        path: 'url-census',
        name: 'url-census',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URLs',
        label: 'URLs',
        title: 'Strategy - URLs'
      },
      // path for URL Census
      {
        path: 'url',
        name: 'url',
        showChildrenInNavbar: false,
        isChildrenVisible: true,
        isUnFilterable: true,
        navBarLabel: 'URLs',
        label: 'URLs',
        title: 'Strategy - URLs',
        children: [
          {
            path: ':id',
            name: 'url_census_edit',
            label: 'Edit',
            title: 'Strategy - URLs - Edit',
            isParam: true
          }
        ]
      },
      {
        path: 'project-notes',
        name: 'project-notes',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Notes',
        label: 'Project Notes',
        title: 'Strategy - Project Notes'
      }
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    children: [
      {
        path: 'section',
        name: 'section',
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Sections',
        label: 'Sections',
        title: 'Settings - Sections'
      },
      {
        path: 'keyword-attributes',
        name: 'keyword-attributes',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Keyword Attributes',
        label: 'Keyword Attributes',
        title: 'Settings - Keyword Attributes'
      },
      {
        path: 'url-attributes',
        name: 'url-attributes',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URL Attributes',
        label: 'URL Attributes',
        title: 'Settings - URL Attributes'
      },
      {
        path: 'web_property',
        name: 'web_property',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Web Properties',
        label: 'Web Properties',
        title: 'Settings - Web Properties'
      },
      {
        path: 'project-settings',
        name: 'project-settings',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Settings',
        label: 'Project Settings',
        title: 'Settings - Project Settings'
      }
    ]
  },
  {
    path: '/data',
    name: 'data',
    children: [
      {
        path: 'imports',
        name: 'imports',
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Imports',
        label: 'Imports',
        title: 'Data - Imports'
      },
      {
        path: 'exports',
        name: 'exports',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Exports',
        label: 'Exports',
        title: 'Data - Exports'
      },
      {
        path: 'link',
        name: 'link',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Link Manager',
        label: 'Link Manager',
        title: 'Data - Link Manager'
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    children: [
      {
        path: 'rank_report',
        name: 'rank_report',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Rank Reports',
        label: 'Rank Reports',
        title: 'System - Rank Reports'
      },
      {
        path: 'clients',
        name: 'clients',
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Projects',
        label: 'Projects',
        title: 'System - Projects',
        children: [
          {
            path: ':id',
            name: 'clients_edit',
            label: 'Edit',
            isParam: true,
            title: 'System - Projects - Edit'
          }
        ]
      },
      {
        path: 'user_manager',
        name: 'user_manager',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'User Manager',
        label: 'User Manager',
        title: 'System - User Manager',
        children: [
          {
            path: ':id',
            name: 'user_manager_edit',
            label: 'Edit',
            isParam: true,
            title: 'System - User Manager - Edit'
          }
        ]
      },
      {
        path: 'agency',
        name: 'agency',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Agency',
        label: 'Agency',
        title: 'System - Agency'
      },
      {
        path: 'background-tasks',
        name: 'background-tasks',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Background Tasks',
        label: 'Background Tasks',
        title: 'System - Background Tasks'
      },
      {
        path: 'status',
        name: 'status',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Statuses',
        label: 'Statuses',
        title: 'System - Statuses'
      },
      {
        path: 'category',
        name: 'category',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Categories',
        label: 'Categories',
        title: 'System - Categories'
      },
      {
        path: 'tag',
        name: 'tag',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Tags',
        label: 'Tags',
        title: 'System - Tags',
        children: [
          {
            path: 'edit',
            name: 'edit',
            label: 'Edit',
            title: 'Edit'
          },
          {
            path: 'upload',
            name: 'upload',
            label: 'Upload',
            title: 'Upload'
          },
          {
            path: 'review',
            name: 'review',
            label: 'Review',
            title: 'Review'
          },
          {
            path: 'children',
            name: 'children',
            label: 'Children',
            title: 'Children'
          }
        ]
      },
      {
        path: 'indexation-tracking',
        name: 'indexation-tracking',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Indexation Tracking',
        label: 'Indexation Tracking',
        title: 'System - Indexation Tracking',
        children: [
          {
            path: ':id',
            name: 'indexation-tracking_history',
            label: 'History',
            isParam: true,
            title: 'History'
          }
        ]
      },
      {
        path: 'url_analyser',
        name: 'url_analyser',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URL Analyser',
        label: 'URL Analyser',
        title: 'System - URL Analyser'
      },
      {
        path: 'authorization',
        name: 'authorization',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        isHiddenInBreadcrumbs: true,
        displayNextChildrenLevel: true,
        label: 'Authorization',
        navBarLabel: 'Authorization',
        children: [
          {
            path: 'user-groups',
            name: 'user-groups',
            navBarLabel: 'User Groups',
            label: 'User Groups',
            title: 'System - User Groups'
          },
          {
            path: 'security-permissions',
            name: 'security-permissions',
            navBarLabel: 'Security Permissions',
            label: 'Security Permissions',
            title: 'System - Security Permissions'
          }
        ]
      }
    ]
  }
]

const allRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    label: 'Dashboard',
    visible: false,
    icon: 'home'
  },
  {
    path: '/reports',
    name: 'reports',
    label: 'Reports',
    icon: 'chart',
    visible: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'rank-zone',
        name: 'rank-zone',
        label: 'Rank Zone',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        isHiddenInBreadcrumbs: true,
        displayNextChildrenLevel: true,
        children: [
          // {
          //   path: 'overview',
          //   name: 'overview',
          //   navBarLabel: 'Overview',
          //   label: 'Rank Zone Reports - Overview',
          //   title: 'Rank Zone Reports | Overview'
          // },
          {
            path: 'progress',
            name: 'progress',
            navBarLabel: 'Progress',
            visible: false,
            label: 'Rank Zone Reports - Progress',
            title: 'Rank Zone Reports | Progress'
          },
          {
            path: 'comparison',
            name: 'comparison',
            navBarLabel: 'Comparison',
            visible: false,
            label: 'Rank Zone Reports - Comparison',
            title: 'Rank Zone Reports | Comparison'
          },
          {
            path: 'sections',
            name: 'sections',
            navBarLabel: 'Sections',
            visible: false,
            label: 'Rank Zone Reports - Sections',
            title: 'Rank Zone Reports | Sections'
          },
          {
            path: 'status',
            name: 'status',
            navBarLabel: 'Status',
            visible: false,
            label: 'Rank Zone Reports - Status',
            title: 'Rank Zone Reports | Status'
          },
          {
            path: 'url',
            name: 'url',
            navBarLabel: 'URL',
            visible: false,
            label: 'Rank Zone Reports - URL',
            title: 'Rank Zone Reports | URL'
          }
        ]
      },
      // TODO: Uncomment when ready
      {
        path: 'grids',
        name: 'product-grid-report',
        visible: false,
        label: 'Product Grid Report',
        showChildrenInNavbar: true
      },
      {
        path: 'keyword-movement-report',
        name: 'keyword-movement-report',
        visible: false,
        label: 'Keyword Movement Report',
        showChildrenInNavbar: true
      },
      {
        path: 'url-movement-report',
        name: 'url-movement-report',
        visible: false,
        label: 'URL Movement Report',
        showChildrenInNavbar: true
      },
      {
        path: 'attribute',
        name: 'attribute',
        visible: false,
        showChildrenInNavbar: true,
        label: 'Attribute Report'
      },
      {
        path: 'link-building',
        name: 'link-building',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Link Building',
        label: 'Link Building',
        title: 'Strategy - Link Building'
      }
    ]
  },
  {
    path: '/strategy',
    name: 'strategy',
    label: 'Strategy',
    icon: 'monitor',
    visible: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'keyword-census',
        name: 'keyword-census',
        visible: false,
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Keywords',
        label: 'Keywords',
        title: 'Strategy - Keywords'
      },
      {
        path: 'url-census',
        name: 'url-census',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URLs',
        label: 'URLs',
        title: 'Strategy - URLs'
      },
      {
        path: 'url-planner',
        name: 'url-planner',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Content Briefs',
        label: 'Content Briefs',
        title: 'Strategy - Content Briefs'
      },
      {
        path: 'calendar',
        name: 'calendar',
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        visible: false,
        navBarLabel: 'Calendar',
        label: 'Calendar',
        title: 'Strategy - Calendar'
      },
      {
        path: 'campaign-guidelines',
        name: 'campaign-guidelines',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Campaign Guidelines',
        label: 'Campaign Guidelines',
        title: 'Strategy - Campaign Guidelines'
      },
      {
        path: 'project-notes',
        name: 'project-notes',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Notes',
        label: 'Project Notes',
        title: 'Strategy - Project Notes'
      },
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    label: 'Settings',
    icon: 'gear',
    visible: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'section',
        name: 'section',
        visible: false,
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Sections',
        label: 'Sections',
        title: 'Settings - Sections'
      },
      {
        path: 'keyword-attributes',
        name: 'keyword-attributes',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Keyword Attributes',
        label: 'Keyword Attributes',
        title: 'Settings - Keyword Attributes'
      },
      {
        path: 'url-attributes',
        name: 'url-attributes',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URL Attributes',
        label: 'URL Attributes',
        title: 'Settings - URL Attributes'
      },
      {
        path: 'web_property',
        name: 'web_property',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Web Properties',
        label: 'Web Properties',
        title: 'Settings - Web Properties'
      },
      {
        path: 'project-settings',
        name: 'project-settings',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Settings',
        label: 'Project Settings',
        title: 'Settings - Project Settings'
      },
      {
        path: 'project-membership',
        name: 'project-membership',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Project Membership',
        label: 'Project Membership',
        title: 'Settings - Project Membership'
      },
      {
        path: 'user-account',
        name: 'user-account',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'My Account',
        label: 'My Account',
        title: 'Settings - My Account'
      },
      {
        path: 'account-checklist',
        name: 'account-checklist',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Setup Checklist',
        label: 'Setup Checklist',
        title: 'Settings - Setup Checklist'
      }
    ]
  },
  {
    path: '/data',
    name: 'data',
    label: 'Data',
    icon: 'list',
    visible: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'imports',
        name: 'imports',
        visible: false,
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Imports',
        label: 'Imports',
        title: 'Data - Imports'
      },
      {
        path: 'exports',
        name: 'exports',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Exports',
        label: 'Exports',
        title: 'Data - Exports'
      },
      {
        path: 'link',
        name: 'link',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Link Manager',
        label: 'Link Manager',
        title: 'Data - Link Manager'
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    label: 'System',
    icon: 'key',
    visible: false,
    isHiddenInBreadcrumbs: true,
    showChildrenInNavbar: true,
    children: [
      {
        path: 'rank_report',
        name: 'rank_report',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Rank Reports',
        label: 'Rank Reports',
        title: 'System - Rank Reports'
      },
      {
        path: 'clients',
        name: 'clients',
        visible: false,
        addChildToRoute: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Projects',
        label: 'Projects',
        title: 'System - Projects',
      },
      {
        path: 'user_manager',
        name: 'user_manager',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'User Manager',
        label: 'User Manager',
        title: 'System - User Manager',
      },
      {
        path: 'billing',
        name: 'billing',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Billing',
        label: 'Billing',
        title: 'System - Billing'
      },
      {
        path: 'agencies',
        name: 'agencies',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Agency Dashboard',
        label: 'Agency Dashboard',
        title: 'System - Agencies'
      },
      {
        path: 'account-info',
        name: 'account-info',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Account Info',
        label: 'Account Info',
        title: 'System - Account'
      },
      {
        path: 'background-tasks',
        name: 'background-tasks',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Background Tasks',
        label: 'Background Tasks',
        title: 'System - Background Tasks'
      },
      {
        path: 'status',
        name: 'status',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Statuses',
        label: 'Statuses',
        title: 'System - Statuses'
      },
      {
        path: 'category',
        name: 'category',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Categories',
        label: 'Categories',
        title: 'System - Categories'
      },
      {
        path: 'tag',
        name: 'tag',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Tags',
        label: 'Tags',
        title: 'System - Tags',
      },
      {
        path: 'indexation-tracking',
        name: 'indexation-tracking',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'Indexation Tracking',
        label: 'Indexation Tracking',
        title: 'System - Indexation Tracking',
      },
      {
        path: 'url_analyser',
        name: 'url_analyser',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        navBarLabel: 'URL Analyser',
        label: 'URL Analyser',
        title: 'System - URL Analyser'
      },
      {
        path: 'authorization',
        name: 'authorization',
        visible: false,
        showChildrenInNavbar: true,
        isChildrenVisible: true,
        isHiddenInBreadcrumbs: true,
        displayNextChildrenLevel: true,
        label: 'Authorization',
        navBarLabel: 'Authorization',
        children: [
          {
            path: 'user-groups',
            name: 'user-groups',
            visible: false,
            navBarLabel: 'User Groups',
            label: 'User Groups',
            title: 'System - User Groups'
          },
          {
            path: 'security-permissions',
            name: 'security-permissions',
            visible: false,
            navBarLabel: 'Security Permissions',
            label: 'Security Permissions',
            title: 'System - Security Permissions'
          }
        ]
      }
    ]
  }
]

export { routes, agencyRoutes, allRoutes }
